import React from 'react';
import ConstructionHeader from './components/ConstructionHeader';
import ContactSection from './components/ContactSection';

const App = () => {
  return (
    <div className="min-h-screen bg-amber-50 flex flex-col">
      <main className="flex-1 flex flex-col">
        <ConstructionHeader />
        <ContactSection />
      </main>
      
      <footer className="py-6 bg-amber-900 text-white text-center">
        <p className="text-sm">© {new Date().getFullYear()} Café Tarapacá. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default App;

// DONE